import { defineStore } from "pinia"

export const useCompanyinfo = defineStore('companyinfo', {
    // defineStore(id(一个储存库标识))
    state: () => ({
        acccompanycode: null,
        address: null,
        address2: null,
        companycode: null,
        companyname: null,
        companyname2: null,
        ctgliab: null,
        departnumber: null,
        email: null,
        expiration: null,
        fax: null,
        id: null,
        memberpositions: null,
        mobilephone: null,
        penumber: null,
        poscash: null,
        senumber: null,
        sharewhcom: null,
        siojournal: null,
        staffnumber: null,
        telephone: null,
        wa: null,
        webmem: null,
        website: null,
        countrycode: null,
        additionalrecord11: null
    })
})